import React, { useState, useEffect } from "react";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { toast } from "react-toastify";

// import JS files
import AdminOrderCard from "../../shares/AdminOrderCard";
import OrderCardLeftPartTemplate from "../../../shares/OrderCardLeftPartTemplate";
import TableIconModal from "../../../shares/TableIconModal";
import useFetch from "../../../../context/useFetch";
import { defaultRingSize } from "../../../../constants/constants";
import SizeTextGrid from "../../../shares/SizeTextGrid";
import { useSetting } from "../../../../context/SettingContext";

const OrderDetails = (props) => {
  const {defaultRingSize} = useSetting()
  let windowWidth = window.screen.width;
  const [openModal, setOpenModal] = useState(false);

  const [currentOerdersDetail, setCurrentOerdersDetail] = useState({
    results: [],
    detail: {},
  });
  const [initialValues, setInitialValues] = useState({});
  const [nums, setNums] = useState(new Array(defaultRingSize + 1).fill(""));
  const update_nums = (ringId, ind, nValue) => {
    let beforeNums = { ...initialValues };

    beforeNums[ringId][ind] = nValue;
    setInitialValues(beforeNums);
  };

  const getCreateOrderDetailsApi = useFetch({
    method: "get",
    url: `Order_Service/${props.selectedRow?.id}/admin_get_order_item_detail_from_order`,
    trigger: false,
    setter: setCurrentOerdersDetail,
    argFunc: (res) => {
      let tmp = {};
      res.results.map((item, ind) => {
        tmp[item.id] = [];
        tmp[item.id].push(item.size_one_num);
        tmp[item.id].push(item.size_two_num);
        tmp[item.id].push(item.size_three_num);
        tmp[item.id].push(item.size_four_num);
        tmp[item.id].push(item.size_five_num);
        tmp[item.id].push(item.size_six_num);
      });

      setInitialValues(tmp);
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const [childrenItemDate, setChildrenItemDate] = useState();

  const move_date_to_parent = (date) => {
    setChildrenItemDate(date);
  };

  useEffect(() => {
    if (openModal == true)
      if (props.selectedRow !== undefined)
        if (props.selectedRow.hasOwnProperty("id")) {
          getCreateOrderDetailsApi.reFetch();
        }
  }, [openModal]);
  return (
    <>
      <TableIconModal
        width="w-11/12"
        icon={<RemoveRedEyeIcon />}
        isOverflow={true}
        isNotBackdropClick={true}
        openModal={openModal}
        setOpenModal={setOpenModal}
      >
        <div>
          <div className="flex justify-center mb-2">
            <div className="add-item-container">
              <span className="show-label">
                کد سفارش:{" "}
                <span className="show-value">
                  {" "}
                  {props.selectedRow?.unique_id}
                </span>
              </span>
            </div>
          </div>
          <div className="border-b border-dashed my-2"></div>
          <SizeTextGrid have5Col haveExtraCol/>
          <div className="overflow-scroll max-h-96">
            {currentOerdersDetail.results.map((item, index) => {
              return [
                <AdminOrderCard
                  item={item}
                  DontshowEditIconForAdmin
                  move_date_to_parent={move_date_to_parent}
                  dateDisabled
                >
                  <OrderCardLeftPartTemplate
                    nums={nums}
                    update_nums={update_nums}
                    dynamicMap={true}
                    data_item={item}
                    ringId={item.id}
                    cantEdit
                    adminCantEdit
                  />
                </AdminOrderCard>,
              ];
            })}
          </div>
        </div>
      </TableIconModal>
    </>
  );
};

export default OrderDetails;
